export default __webpack_public_path__ + "static/media/icon_faction_survivor.4f63dce5.png";